// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3sCeU","fileBtn":"File_fileBtn__3yi6-","closeBtn":"File_closeBtn__3LRVc","fileSelected":"File_fileSelected__27dUk","disabled":"File_disabled__2hUIz"};